import Request from './request'

const Device_Simcard_Group = {
  getSimcardsGroups(callback) {
    Request.get('device-simcard-group/index').then(callback).catch(this.bad_answer)
  },
  addSimcardGroup (params, callback) {
    Request.post('device-simcard-group/add', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  deleteSimcardGroup (params, callback) {
    Request.post('device-simcard-group/delete', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  updateSimcardGroup (params, callback) {
    Request.post('device-simcard-group/update', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },

}
export default Device_Simcard_Group
